import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx"; // Tambahkan ekstensi jika diperlukan

import "./index.css"; // Jika ada file CSS

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
